<template>
  <div class="homeMain">
    <div class="homeLeft">
      <div class="homeMap">
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle1"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle2"
        />
        <img
          src="../../../assets/supervise/borderTrange.png"
          alt=""
          srcset=""
          class="trangle trangle3"
        />
        <img
          src="../../../assets/supervise/borderRight.png"
          alt=""
          srcset=""
          class="trangleRight"
        />
        <div id="serveMap" class="serveMap"></div>
      </div>
      <div class="homeVersion">
        <img
          src="../../../assets/supervise/homeBottom.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="versionBox">
          <div class="versionLeft">
            <p class="serveTitle">服务老人</p>
            <div class="echartBox">
              <div class="echartAge" id="echartAge"></div>
              <div class="echartSecure" id="echartSecure"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="homeCenter">
      <div class="socialCenterTop">
        <img
          src="../../../assets/supervise/socailCenterTop.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <div class="serveObjTop">
          <p class="sertitle">站点分布</p>
          <div class="serveBox">
            <div class="serveOther" @click="getServeTypes(1, 5)">
              <img src="../../../assets/supervise/fwz.png" alt="" srcset="" />
              <p>
                <span class="name">机构</span><br />
                <span class="nums">{{ stationCount }}</span>
              </p>
            </div>
            <div class="serveOther" @click="getServeTypes(2, serveCount)">
              <img src="../../../assets/supervise/serp.png" alt="" srcset="" />
              <p>
                <span class="name">服务人员</span><br />
                <span class="nums" style="color: #2cd1c0">{{
                  serveCount
                }}</span>
              </p>
            </div>
          </div>
          <p class="sertitle today">站点服务体系</p>
          <div class="serveBox">
            <div class="serveOther">
              <img src="../../../assets/supervise/hlzc.png" alt="" srcset="" />
              <p>
                <span class="name">惠老政策</span><br />
                <span class="nums" style="color: #fefe00">{{ num2 }}</span>
              </p>
            </div>
            <div class="serveOther">
              <img src="../../../assets/supervise/xwzx.png" alt="" srcset="" />
              <p>
                <span class="name">新闻资讯</span><br />
                <span class="nums" style="color: #975fe4">{{ num1 }}</span>
              </p>
            </div>
            <div class="serveOther">
              <img src="../../../assets/supervise/tzgg.png" alt="" srcset="" />
              <p>
                <span class="name">通知公告</span><br />
                <span class="nums" style="color: #fbb828">{{ num3 }}</span>
              </p>
            </div>
            <div class="serveOther">
              <img src="../../../assets/supervise/bszn.png" alt="" srcset="" />
              <p>
                <span class="name">办事指南</span><br />
                <span class="nums" style="color: #fbb828">{{ num4 }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="socialCenterBottom">
        <img
          src="../../../assets/supervise/socialCenterBottom.png"
          class="companyImg"
          alt=""
          srcset=""
        />

        <p class="serveTitle">社区养老</p>
        <div class="inspectionTop">
          <div class="itemSite">
            <p class="siteTitle">就餐人员</p>
            <div class="siteShaw">{{ oldCount }}</div>
          </div>
          <div class="itemSite">
            <p class="siteTitle">服务人员</p>
            <div class="siteShaw">{{ servicePerson }}</div>
          </div>
        </div>
        <div id="socialOld"></div>
      </div>
    </div>
    <div class="homeRight">
      <div class="socialRightTop">
        <img
          src="../../../assets/supervise/socialRight.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">安全巡检</p>
        <div class="inspectionTop">
          <div class="itemSite">
            <p class="siteTitle">回访总量</p>
            <div class="siteShaw">{{ informationVisit }}</div>
          </div>

          <div class="itemSite">
            <p class="siteTitle">走访总量</p>
            <div class="siteShaw">{{ visit }}</div>
          </div>
        </div>
        <div id="safe"></div>
      </div>
      <div class="socialRightBottom">
        <img
          src="../../../assets/supervise/socialRight.png"
          class="companyImg"
          alt=""
          srcset=""
        />
        <p class="serveTitle">监控</p>
        <div class="videoBox">
          <iframe
            :src="`https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/${this.vodelist[0].sequence}/${this.vodelist[0].channel}.live&autoplay=1&audio=1&accessToken=${this.vodelist[0].token}&templete=2`"
            width="100%"
            height="100%"
            id="ysopen"
            allowfullscreen
          >
          </iframe>
        </div>
      </div>
    </div>
    <!-- 弹窗 start -->
    <div class="maskModel" v-if="isMasked">
      <div class="yearMoney">
        <p class="name">基本信息</p>
        <img
          src="../../../assets/supervise/normalCanle.png"
          alt=""
          srcset=""
          @click="closeInfo"
          class="maskClose"
        />
      </div>
      <div class="personFlex">
        <img
          v-if="maskdata.personPhoto == null"
          src="../../../assets/supervise/photo.png"
          class="img"
          alt=""
          srcset=""
        />
        <img v-else :src="maskdata.personPhoto" class="img" alt="" srcset="" />
        <div class="personConent">
          <ul>
            <li>姓名：{{ maskdata.personName }}</li>
            <li>性别：{{ maskdata.personSex == 1 ? "男" : "女" }}</li>
            <li>年龄：{{ maskdata.personAge }}</li>
            <li>手机号码：{{ maskdata.personPhone }}</li>
            <li>机构点：{{ maskdata.serviceStationName }}</li>
            <li>
              职位：
              <span v-if="maskdata.position == 1">站长</span>
              <span v-if="maskdata.position == 2">副站长</span>
              <span v-if="maskdata.position == 3">普通员工</span>
            </li>
            <li>
              家政经验：
              <span v-if="maskdata.familyExperience == 0">有</span>
              <span v-if="maskdata.familyExperience == 1">无</span>
            </li>
            <li>区域名称：{{ maskdata.areaName }}</li>
            <li>地址：{{ maskdata.address }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request.js"
import Highcharts from "highcharts/highstock"
import Highcharts3D from "highcharts/highcharts-3d"
import exportVue from "@/utils/exportVue"
Highcharts3D(Highcharts)
export default {
  data() {
    return {
      vodelist: [
        {
          sequence: "",
          channel: "",
          token: "",
        },
      ],
      normalInfo: {},
      stationCount: 0,
      zoufangTotal: {},
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      markers: [],
      dataList: [],
      recMap: null,
      recIsMap: true,
      serveCount: 0,
      serveStationCount: 0,
      ServationData: [],
      serverData: [],
      accessKey: "f53a1def26d34d6dbdc91a6b70dbd9b2",
      accessSecret: "70d7c4cf7dd218786a57d0bf95f38d47",
      control: "",
      num1: "0",
      num2: "0",
      num3: "0",
      num4: "0",
      isMasked: false,
      maskdata: [],
      zxdata: [],
      zxdata1: [],
      zxdata2: [],
      dateArray: [],
      informationVisit: "0",
      visit: "0",
      servicePerson: "0",
      oldCount: "0",
      dataIds: [],
    }
  },
  created() {
    exportVue.$on("dataIds", (data) => {
      if (data) {
        this.dataIds = data
      }
    })
  },
  watch: {
    dataIds(val) {
      if (val) {
        this.myMap.remove(this.markers)
        this.markers = []
        this.initMarker(val)
        this.getServation(val)
        this.getSourceData(val) //经济情况占比
        this.getAgeData(val)
        this.getStationData(val) //获取机构数量
        this.getManageData(val) //获取惠老政策数据
        this.getFangTotal(val) //获取走访得数量
        this.getEatSatis(val) //获取就餐以及服务人员数量
        this.getvodes(val)
      }
    },
  },
  async mounted() {
    // this.getvode()
    this.getOrg()
    // this.getSafe()
    // this.getSocial()
    this.getSourceData() //经济情况占比
    this.getAgeData() //年龄段占比
    this.getStationData() //获取机构数量
    // await this.loadmap().then(() => {
    //     this.initMarker()
    //     this.getServation()
    // })
    // await this.getDistrictss("341100")
    //获取当前日期以及七天内
    this.getEatrecord() //就餐记录
    this.getManageData() //获取惠老政策数据
    this.getFangTotal() //获取走访得数量
    this.getEatSatis() //获取就餐以及服务人员数量
    this.getvodes()
  },
  _methods: {
    //获取监控链接
    getvode() {
      fetch("https://open.ys7.com/api/lapp/token/get", {
        method: "POST",
        body: `appKey=${this.accessKey}&appSecret=${this.accessSecret}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          this.control = res.data.accessToken
        })
    },
    getvodes(dataIds) {
      this.vodelist = [
        {
          sequence: "",
          channel: "",
          token: "",
        },
      ]
      this.$http
        .request({
          url: "ypt/admin/monitorManagement/info/getMonitor",
          method: "POST",
          data: {
            flag: 7,
            dataIds: dataIds,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            //console.log(res.content.length)
            if (res.content.length > 0) {
              this.vodelist = res.content
            } else {
              this.vodelist = [
                {
                  sequence: "",
                  channel: "",
                  token: "",
                },
              ]
            }
          }
        })
    },
    closeInfo() {
      this.isMasked = false
      this.maskdata = []
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1,
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "",
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    getOrg() {
      const self = this
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then(async (res) => {
          if (res.code == 200) {
            this.normalInfo = res.content

            if (res.content.latitude && res.content.longitude) {
              setTimeout(async () => {
                await self.$nextTick(() => {
                  self.loadmap(res.content.longitude, res.content.latitude)
                  self.initMarker()
                  self.getServation()
                })
              }, 30)
            } else {
              let provinceList = [],
                cityList = [],
                areaList = [],
                streetList = [],
                communityList = [],
                longitude = "",
                latitude = ""
              let province = await this.getDistricts()
              provinceList = province.districtList
              if (this.normalInfo.provinceId) {
                let city = await this.getDistricts(this.normalInfo.provinceId)
                cityList = city.districtList
              }
              if (this.normalInfo.cityId) {
                let area = await this.getDistricts(this.normalInfo.cityId)
                areaList = area.districtList
              }
              if (this.normalInfo.areaId) {
                let street = await this.getStreetList(this.normalInfo.areaId)
                streetList = street
              }
              if (this.normalInfo.streetId) {
                let community = await this.getCommityList(
                  Number(this.normalInfo.streetId)
                )
                communityList = community
              }
              if (
                this.normalInfo.orgLevel == 1 ||
                this.normalInfo.orgLevel == 0
              ) {
                provinceList.forEach((item) => {
                  if (item.adcode == this.normalInfo.provinceId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                    console.log()
                  }
                })
              } else if (this.normalInfo.orgLevel == 2) {
                cityList.forEach((item) => {
                  if (item.adcode == this.normalInfo.cityId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              } else if (this.normalInfo.orgLevel == 3) {
                areaList.forEach((item) => {
                  if (item.adcode == this.normalInfo.areaId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
              ) {
                streetList.forEach((item, index) => {
                  if (item.adcode + index == this.normalInfo.streetId) {
                    latitude = item.center.lat
                    longitude = item.center.lng
                  }
                })
              }

              setTimeout(async () => {
                await self.$nextTick(() => {
                  self.loadmap(longitude, latitude)
                  self.initMarker()
                  self.getServation()
                })
              }, 30)
            }
            var polygonArr = []
            if (res.content.pointPosition) {
              res.content.pointPosition.split(",").forEach((e) => {
                polygonArr.push(e.split(":"))
              })
            }
            var polygon = new AMap.Polygon({
              map: self.myMap,
              path: polygonArr,
              strokeColor: res.content.gridColour ? res.content.gridColour : "",
              strokeOpacity: 0.2,
              strokeWeight: 3,
              fillColor: res.content.gridColour ? res.content.gridColour : "",
              fillOpacity: 0.35,
              extData: {
                name: res.content.gridColour ? res.content.orgName : "",
              },
            })
            this.polygon = polygon
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //加载地图
    loadmap(longitude, latitude) {
      console.log(this.$store.state.orgAreaLevel)
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("serveMap", {
          resizeEnable: true,
          zoom: 8,
          // postion: [longitude, latitude],
          mapStyle: "amap://styles/blue",
        })
        if (
          this.$store.state.orgAreaLevel == 1 ||
          this.$store.state.orgAreaLevel == 2 ||
          this.$store.state.orgAreaLevel == 3
        ) {
          let cities = [this.$store.state.orgAreaName]
          for (let i = 0; i < cities.length; i++) {
            self.areaBG(self.myMap, cities[i])
            // self.myMap.setZoom(8)
            self.myMap.setZoomAndCenter(6, [longitude, latitude])
          }
        } else if (
          this.$store.state.orgAreaLevel == 4 ||
          this.$store.state.orgAreaLevel == 5
        ) {
          console.log("社区，街道", this.$store.state.orgId)

          if (this.$store.state.orgId != 0) {
            this.$http
              .request({
                url: "/rbac/admin/org/info/findOrgById",
                method: "POST",
                data: {
                  id: this.$store.state.orgId,
                },
              })
              .then((res) => {
                var polygonArr = []
                res.content.pointPosition.split(",").forEach((i) => {
                  console.log(i)
                  polygonArr.push(i.split(":"))
                })
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  path: polygonArr,
                  fillOpacity: 0.3,
                  fillColor: "#2191E6",
                  strokeColor: "#007CDB",
                })
                let maxlng = polygonArr[0].lng
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  maxlng =
                    maxlng < polygonArr[i + 1].lng
                      ? polygonArr[i + 1].lng
                      : maxlng
                }
                let minlng = polygonArr[0].lng
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  minlng =
                    minlng > polygonArr[i + 1].lng
                      ? polygonArr[i + 1].lng
                      : minlng
                }
                let lngs =
                  parseInt(minlng) + (parseInt(maxlng) - parseInt(minlng)) / 2
                let maxlat = polygonArr[0].lat
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  maxlat =
                    maxlat < polygonArr[i + 1].lat
                      ? polygonArr[i + 1].lat
                      : maxlat
                }
                let minlat = polygonArr[0].lat
                for (let i = 0; i < polygonArr.length - 1; i++) {
                  minlat =
                    minlat > polygonArr[i + 1].lat
                      ? polygonArr[i + 1].lat
                      : minlat
                }
                let lats =
                  parseInt(minlat) + (parseInt(maxlat) - parseInt(minlat)) / 2
                self.myMap.setZoomAndCenter(7, [lngs, lats])
                //self.myMap.setZoomAndCenter(14, [polygonArr[0].lng, polygonArr[0].lat])
                self.polygon.setMap(self.myMap)
              })
          }
        }
        resolve()
      })
    },
    areaBG(map, cityName) {
      console.log(cityName, "cityName")
      AMap.service("AMap.DistrictSearch", function () {
        let opts = {
          subdistrict: 0,
          extensions: "all",
          level: "district", // 查询行政级别为市
        }
        // 实例化DistrictSearch
        let district = new AMap.DistrictSearch(opts)
        district.setLevel("district")
        // 行政区查询
        district.search(`${cityName}`, function (status, result) {
          // 获取边界信息
          let bounds = result.districtList[0].boundaries
          let polygons = []
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              // 生成行政区划polygon
              let polygon = new AMap.Polygon({
                map: map,
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.3,
                fillColor: "#2191E6",
                strokeColor: "#007CDB",
              })
              polygons.push(polygon)
              console.log(polygon)
            }
          }
        })
      })
    },
    //渲染区域信息
    getDistrictss(city, chooseCity = "") {
      return new Promise((resolve, rejcet) => {
        let self = this
        //根据市获取下一级行政区
        let opts = {
          subdistrict: 1,
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let tempArr = []
        let district = new AMap.DistrictSearch(opts) //注意：需要使用插件同步下发功能才能这样直接使用
        district.search(city, function (status, result) {
          if (status == "complete") {
            result.districtList[0].districtList.forEach((item) => {
              tempArr.push(item.name)
            })
            console.log(tempArr, chooseCity, "信息")
            if (!chooseCity) {
              tempArr.forEach((item, index) => {
                self.renderPolygon(district, item, index)
              })
            } else {
              tempArr.forEach((item, index) => {
                if (item == chooseCity) {
                  self.renderPolygon(district, item, index)
                } else {
                  console.log("没有当前区域")
                }
              })
            }
            resolve()
          }
        })
      })
    },
    //渲染行政区边界
    // renderPolygon(district, item, index) {
    //     let self = this
    //     let color = [
    //         "#f73131",
    //         "#fff816",
    //         "#ff16d8",
    //         "#709438",
    //         "#25A5F7",
    //         "#315EFB",
    //         "#771CAA",
    //         "#045206",
    //         "#6ec55e",
    //         "#e8ac00",
    //         "#f77325",
    //         "#1d15a0",
    //         "#39fda2",
    //     ]
    //     self.myMap.remove(self.polygons)
    //     self.polygons.length = []
    //     district.search(item, function (status, result) {
    //         let bounds = result.districtList[0].boundaries
    //         self.polygon = null
    //         if (bounds) {
    //             for (let i = 0, l = bounds.length; i < l; i++) {
    //                 self.polygon = new AMap.Polygon({
    //                     strokeWeight: 1,
    //                     path: bounds[i],
    //                     fillOpacity: 0.4,
    //                     fillColor: color[index],
    //                     strokeColor: color[index],
    //                     strokeStyle: item,
    //                 })
    //                 self.polygons.push(self.polygon)
    //             }
    //         }
    //         // self.polygon.on("click", function (e) {
    //         //     self.myMap.remove(self.polygons)
    //         //     let polygon = new AMap.Polygon({
    //         //         strokeWeight: 1,
    //         //         path: e.target.w.path,
    //         //         fillOpacity: 0.4,
    //         //         fillColor: e.target.w.strokeColor,
    //         //         strokeColor: e.target.w.strokeColor,
    //         //     })
    //         //     self.polygons.push(polygon)
    //         //     self.myMap.add(polygon)
    //         //     // self.map.setFitView(polygon);
    //         //     self.myMap.setZoom(10)
    //         // })
    //         self.myMap.add(self.polygons)
    //         self.myMap.setFitView(self.polygons) //视口自适应
    //     })
    // },
    async getServeTypes(type, num) {
      console.log(type, num)
      const self = this
      self.myMap.remove(self.markers)
      self.markers = []
      if (type == 1 && num > 0) {
        console.log("2222")
        setTimeout(async () => {
          await self.$nextTick(() => {
            self.getServation()
          })
        })
      } else if (type == 2 && num > 0) {
        this.initMarker()
      }
    },
    //服务人员打点
    initMarker(dataIds) {
      this.myMap.remove(this.markers)
      this.markers = []
      this.$http
        .request({
          url: "/ypt/admin/serviceStaff/info/findList",
          method: "POST",
          data: {
            pageSize: 100,
            pageNo: 1,
            dataIds: dataIds,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.serveCount = res.content.count
            this.serverData = res.content.list
            res.content.list.forEach((item, index) => {
              item.tubiao = require("../../../assets/supervise/serp.png")
              item.typeId = "serveData"
              item.latitude = Number(item.latitude)
              item.longitude = Number(item.longitude)
            })
            console.log(res.content.list, "服务人员")
            this.goPoint(res.content.list)
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },

    //机构
    getServation(dataIds) {
      this.myMap.remove(this.markers)
      this.markers = []
      this.$http
        .request({
          url: "/ypt/admin/communityCare/info/findLocation",
          method: "POST",
          data: { dataIds: dataIds },
        })
        .then((res) => {
          if (res.code == 200) {
            this.ServationData = res.content
            res.content.forEach((item, index) => {
              item.tubiao = require("../../../assets/supervise/fwz.png")
              item.typeId = "fuwuzhan"
              item.latitude = Number(item.latitude)
              item.longitude = Number(item.longitude)
            })
            console.log(res.content, "机构")
            this.goPoint(res.content)
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    // 打点
    goPoint(data) {
      const self = this
      console.log("222")
      // console.log(self.markers, "坐标集合")
      self.infoWindow = new AMap.InfoWindow({
        offset: new AMap.Pixel(0, -30),
        // isCustom: true,
      })
      console.log(data)
      data.forEach((item) => {
        if (item.longitude && item.latitude) {
          let marker = new AMap.Marker({
            position: [item.longitude, item.latitude],
            icon: new AMap.Icon({
              image: item.tubiao,
              size: new AMap.Size(50, 50),
              imageSize: new AMap.Size(20, 20),
            }),
          })
          console.log(item.photo)

          marker.content = `<div class="mapModel">
                                    <p class="mapTitle"><span class="name">站点信息</span></p>
                                    <ul class="mapUl">
                                        <li class="mapLi"><span class="name">站点名称：</span><p class="content">${item.organizationName}</p></li>
                                        <li class="mapLi"><span class="name">站点类型：</span><p class="content">居家养老机构</p></li>
                                        <li class="mapLi"><span class="name">联系电话：</span><p class="content">${item.telphone}</p></li>
                                        <li class="mapLi"><span class="name">联系地址：</span><p class="content">${item.address}</p></li>
                                        <li class="mapLi"><span class="name">站点图片：</span><img src="item.photo" class='imgs'> </li>
                                        
                                    </ul>
                                    </div>`

          self.markers.push(marker)

          marker.on("click", (e) => {
            if (item.typeId == "fuwuzhan") {
              this.markerClick(e)
              if (item.id == 50) {
                this.serveCount = this.serveCount + 2 //服务人员
                this.ylry = Math.ceil(this.serveCount / 2) //养老人员
                this.znsb = Math.ceil(this.ylry * 1.5) //智能设备
                this.ycry = this.serveCount + 10 //用餐人员
                this.hs = Math.ceil(this.ylry / 2) //户数
                this.dfrs = this.serveCount - 3 //到访人数
                this.tlsj = this.dfrs * 9 //停留时间
                this.zxdata = [12, 22, 30, 120, 70, 25, 25]
                this.zxdata1 = [4, 14, 24, 3, 19, 1, 15]
                this.zxdata2 = [24, 30, 12, 8, 10, 12, 3]
              }
              if (item.id == 49) {
                this.serveCount = this.serveCount + 4 //服务人员
                this.ylry = Math.ceil(this.serveCount / 2) //养老人员
                this.znsb = Math.ceil(this.ylry * 1.4) //智能设备
                this.ycry = this.serveCount + 6 //用餐人员
                this.hs = Math.ceil(this.ylry / 2) //户数
                this.dfrs = this.serveCount - 2 //到访人数
                this.tlsj = this.dfrs * 8 //停留时间
                this.zxdata = [12, 22, 14, 30, 12, 22, 30]
                this.zxdata1 = [4, 30, 22, 16, 5, 15, 1]
                this.zxdata2 = [11, 16, 3, 23, 15, 9, 30]
              }
              if (item.id == 49) {
                this.serveCount = this.serveCount + 4 //服务人员
                this.ylry = Math.ceil(this.serveCount / 2) //养老人员
                this.znsb = Math.ceil(this.ylry * 1.4) //智能设备
                this.ycry = this.serveCount + 6 //用餐人员
                this.hs = Math.ceil(this.ylry / 2) //户数
                this.dfrs = this.serveCount - 1 //到访人数
                this.tlsj = this.dfrs * 8 //停留时间
                this.zxdata = [10, 20, 15, 22, 5, 11, 33]
                this.zxdata1 = [14, 24, 15, 10, 5, 19, 21]
                this.zxdata2 = [21, 22, 32, 12, 15, 25, 11]
              }
              if (item.id == 48) {
                this.serveCount = this.serveCount + 1 //服务人员
                this.ylry = Math.ceil(this.serveCount / 2) //养老人员
                this.znsb = Math.ceil(this.ylry * 1.3) //智能设备
                this.ycry = this.serveCount + 8 //用餐人员
                this.hs = Math.ceil(this.ylry / 2) //户数
                this.dfrs = this.serveCount - 2 //到访人数
                this.tlsj = this.dfrs * 7 //停留时间
                this.zxdata = [10, 5, 13, 20, 14, 32, 11]
                this.zxdata1 = [4, 22, 5, 20, 14, 2, 22]
                this.zxdata2 = [2, 22, 13, 5, 5, 11, 16]
              }
              if (item.id == 52) {
                this.serveCount = this.serveCount + 6 //服务人员
                this.ylry = Math.ceil(this.serveCount / 2) //养老人员
                this.znsb = Math.ceil(this.ylry * 1.2) //智能设备
                this.ycry = this.serveCount + 8 //用餐人员
                this.hs = Math.ceil(this.ylry / 2) //户数
                this.dfrs = this.serveCount - 2 //到访人数
                this.tlsj = this.dfrs * 4 //停留时间
                this.zxdata = [5, 14, 32, 10, 9, 12, 30]
                this.zxdata1 = [4, 8, 13, 20, 1, 10, 30]
                this.zxdata2 = [10, 12, 3, 20, 5, 32, 12]
              }
            }
            if (item.typeId == "serveData") {
              this.isMasked = true
              this.serverData.forEach((item1) => {
                if (item1.id == item.id) {
                  this.maskdata = item1
                }
              })
            }
          })
        }
      })
      self.myMap.add(self.markers)
      self.myMap.add(self.polygons)
      self.myMap.setFitView(self.polygons) //视口自适应
    },
    //    getById(id){
    //      this.$http
    //         .request({
    //         url: "/ypt/admin/serviceStaff/info/getById",
    //         method: "POST",
    //         data: {
    //             id: id,
    //         },
    //         })
    //         .then(async (res) => {
    //             if (res.code == 200) {
    //                   if(res.content !=null){
    //                       this.maskdata= res.content
    //                   }
    //             }else{
    //                  this.$message({
    //                     message: "根据ID获取信息失败",
    //                     type: "error",
    //                     })
    //             }
    //           })
    // },
    markerClick(e) {
      console.log(e)
      this.infoWindow.setContent(e.target.content)
      this.infoWindow.open(this.myMap, e.target.getPosition())
    },
    getSourceData(dataIds) {
      const that = this
      request({
        url: "/ypt/admin/all/customer/info/economicSource ",
        method: "POST",
        data: { dataIds: dataIds },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content != null) {
            let sourcedatas = []
            this.sourcedatas = res.content[0]
          }
          console.log(this.sourcedatas, "assad")
          this.getSecure(this.sourcedatas)
        }
      })
    },
    // 经济分布
    getSecure(sourcedatas) {
      var chart = Highcharts.chart("echartSecure", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
          backgroundColor: "rgba(255, 255, 255, 0)",
        },
        title: {
          text: "经济情况占比",
          x: 0,
          y: 20,
          style: {
            fontSize: 14,
            color: "#fff",
          },
        },
        exporting: {
          enabled: false, //用来设置是否显示‘打印’,'导出'等功能按钮，不设置时默认为显示
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            innerSize: 100,
            depth: 55,
          },
        },
        series: [
          {
            name: "经济情况占比",
            data: [
              ["子女赡养", sourcedatas.type2],
              ["养老金", sourcedatas.type1],
              ["救济优抚", sourcedatas.type3],
              ["兼职", sourcedatas.type4],
              ["其他", sourcedatas.type5],
            ],
          },
        ],
      })
    },
    getAgeData(dataIds) {
      const that = this
      request({
        url: "/ypt/admin/all/customer/info/findCustomerAgeStatistics",
        method: "POST",
        data: { dataIds: dataIds },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content != null) {
            let agedatas = []
            this.agedatas = [
              { value: res.content.total1, name: "50-59岁" },
              { value: res.content.total2, name: "60-64岁" },
              { value: res.content.total3, name: "65-69岁" },
              { value: res.content.total4, name: "70-79岁" },
              { value: res.content.total5, name: "80-89岁" },
              { value: res.content.total6, name: "90岁以上" },
            ]
          }
          console.log(this.agedatas, "assad")
          this.getAges(this.agedatas)
        }
      })
      this.getAges()
    },

    // 获取年龄分段
    getAges() {
      let mayChart = this.$echarts.init(document.getElementById("echartAge"))
      let option
      option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} :  ({d}%)",
        },
        color: [
          "#3BA0FF",
          "#36CBCB",
          "#4DCB73",
          "#FAD337",
          "#F2637B",
          "#975FE4",
        ],
        title: {
          text: "年龄段占比",
          x: "40",
          y: "20",
          textStyle: {
            fontSize: 14,
            color: "#fff",
          },
        },
        legend: {
          top: "5%",
          left: "70%",
          orient: "vertical",
          top: "center",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
        },

        series: [
          {
            name: "年龄段占比",
            type: "pie",
            radius: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.agedatas,
          },
        ],
      }
      option && mayChart.setOption(option)
    },
    getNowtime() {
      var myDate = new Date() // 获取今天日期
      myDate.setDate(myDate.getDate() - 6)
      var dateArray = []
      var dateTemp
      var flag = 1
      for (var i = 0; i < 7; i++) {
        dateTemp = myDate.getMonth() + 1 + "-" + myDate.getDate()
        dateArray.push(dateTemp)
        myDate.setDate(myDate.getDate() + flag)
      }
      this.echartSafe(dateArray)
    },
    getStationData(dataIds) {
      this.$http
        .request({
          url: "/ypt/admin/serviceStaff/info/staffCount",
          method: "POST",
          data: { dataIds: dataIds },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              this.stationCount = res.content[0].serviceStation
              this.serveCount = res.content[0].staffCount
            }
          }
        })
    },
    //获取就餐人员 服务人员
    getEatSatis(dataIds) {
      this.$http
        .request({
          url: "/sqyl/admin/customer/info/findOldCount",
          method: "POST",
          data: { dataIds: dataIds },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              this.oldCount = res.content[0].oldCount
              this.servicePerson = res.content[0].servicePerson
            }
          }
        })
    },
    //获取走访总量
    getFangTotal(dataIds) {
      this.informationVisit = "0"
      this.visit = "0"
      this.zoufangTotal = "0"
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/findServeType",
          method: "POST",
          data: { dataIds: dataIds },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              this.informationVisit = res.content.informationVisit
              this.visit = res.content.visit
              this.zoufangTotal = res.content
              this.getNowtime()
            } else {
              this.informationVisit = "0"
              this.visit = "0"
              this.zoufangTotal = "0"
            }
          }
        })
    },
    //获取惠老政策 等数据
    getManageData(dataIds) {
      this.$http
        .request({
          url: "/ypt/admin/newsConsulting/info/findView",
          method: "POST",
          data: { dataIds: dataIds },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              this.num1 = res.content[0].num1
              this.num2 = res.content[0].num2
              this.num3 = res.content[0].num3
              this.num4 = res.content[0].num4
            }
          }
        })
    },
    getEatrecord(dataIds) {
      this.$http
        .request({
          url: "/sqyl/consumeRecord/info/findConsumeRecord",
          method: "POST",
          data: { dataIds: dataIds },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content) {
              this.dataList = res.content
              this.echartSocial()
            }
          }
        })
    },
    unique(arr) {
      return Array.from(new Set(arr))
    },
    //社区养老
    echartSocial(dateArray) {
      let mayChart1 = this.$echarts.init(document.getElementById("socialOld"))
      console.log(this.dataList, "this.dataList")
      let xData = []
      let xArr = []
      let aData = []
      let bData = []
      let cData = []
      let part = this.dataList
      part.forEach((item) => {
        xData.push(item.consumeDay)
      })
      xArr = this.unique(xData)
      xArr.forEach((item) => {
        part.forEach((it) => {
          if (item == it.consumeDay && it.breakfastCount) {
            aData.push(it.breakfastCount)
          }
          if (item == it.consumeDay && it.lunchCount) {
            bData.push(it.lunchCount)
          }
          if (item == it.consumeDay && it.dinnerCount) {
            cData.push(it.dinnerCount)
          }
        })
      })
      console.log(xArr, aData, bData, cData, "数据")
      var option
      option = {
        color: [
          "#f47920",
          "#ED75FF",
          "#68D1B4",
          "#8FBC8B",
          "#483D8B",
          "#2F4F4F",
          "#00CED1",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // data: ["早餐", "午餐", "晚餐"],
          data: ["午餐", "晚餐"],
          textStyle: {
            fontSize: 10,
            color: "#fff",
          },
          top: "5%",
          smooth: true,
        },
        grid: {
          left: "3%",
          right: "11%",
          bottom: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xArr,
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 320, //角度顺时针计算的
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#fff",
              width: "1", //坐标线的宽度
            },
          },
        },
        series: [
          // {
          //     name: "早餐",
          //     type: "line",
          //     data: aData,
          //     smooth: true,
          // },
          {
            name: "午餐",
            type: "line",
            data: bData,
            smooth: true,
          },
          {
            name: "晚餐",
            type: "line",
            data: cData,
            smooth: true,
          },
        ],
      }
      option && mayChart1.setOption(option)
    },
    //安全巡检
    // getSafe() {
    //     this.zxdata = [0, 0, 0, 0, 0, 0, 0]
    //     this.zxdata1 = [3, 8, 24, 16, 28, 11, 35]
    //     this.zxdata2 = [1, 5, 12, 7, 18, 12, 30]
    // },
    //安全巡检
    echartSafe(dateArray) {
      this.zoufangTotal
      this.zxdata1 = [
        this.zoufangTotal.vdays7,
        this.zoufangTotal.vdays6,
        this.zoufangTotal.vdays5,
        this.zoufangTotal.vdays4,
        this.zoufangTotal.vdays3,
        this.zoufangTotal.vdays2,
        this.zoufangTotal.vdays1,
      ]
      this.zxdata2 = [
        this.zoufangTotal.idays7,
        this.zoufangTotal.idays6,
        this.zoufangTotal.idays5,
        this.zoufangTotal.idays4,
        this.zoufangTotal.idays3,
        this.zoufangTotal.idays2,
        this.zoufangTotal.idays1,
      ]
      console.log(this.zxdata1, "this.zxdata1")
      let mayChart = this.$echarts.init(document.getElementById("safe"))
      let option
      option = {
        tooltip: {
          trigger: "axis",
        },
        color: ["#2B94F2", "#FBB828"],
        legend: {
          data: ["当日走访量", "当日回访量"],
          right: "0",
          textStyle: {
            fontSize: 12,
            color: "#fff",
          },
        },
        grid: {
          left: "9%",
          top: "18%",
          right: "3%",
          bottom: "18%",
          containLabel: false,
        },
        xAxis: {
          type: "category",
          data: dateArray,
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            name: "当日走访量",
            data: this.zxdata1,
            type: "line",
            smooth: true,
          },
          {
            name: "当日回访量",
            data: this.zxdata2,
            type: "line",
            smooth: true,
          },
        ],
      }
      option && mayChart.setOption(option)
    },
  },
  get methods() {
    return this._methods
  },
  set methods(value) {
    this._methods = value
  },
  destroyed() {},
}
</script>
<style lang="less" scoped>
.homeMain {
  position: relative;
  padding: 0px 12px;
  display: flex;
  max-width: 1920px;
  margin: auto;
  .serveTitle {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    padding-left: 22px;
    padding-top: 20px;
  }
  .companyImg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .homeLeft {
    flex: 1;
    width: 0;
    .homeVersion {
      position: relative;
      width: 100%;
      height: 29vh;
      margin-top: 12px;
      .versionBox {
        display: flex;
        .versionLeft {
          flex: 1;
          .echartBox {
            display: flex;
            .echartAge {
              flex: 1;
              height: 25vh;
            }
            .echartSecure {
              flex: 1;
              height: 25vh;
            }
          }
        }
        .versionRight {
          width: 230px;

          .versionNum {
            display: flex;
            align-items: center;
            margin-top: 12px;
            flex-wrap: wrap;
            .versionItem {
              width: 50%;
              text-align: center;
              .versionImgs {
                position: relative;
                height: 90px;
                img {
                  display: inline-block;
                  width: 80px;
                  height: 90px;
                }
                span {
                  line-height: 90px;
                  color: #01b1ff;
                  font-size: 18px;
                  position: absolute;
                  left: 0;
                  width: 100%;
                  z-index: 10;
                }
              }
              .versionTitle {
                color: #fff;
                font-size: 15px;
              }
            }
          }
        }
      }
    }
    .homeMap {
      width: 100%;
      position: relative;
      height: 60vh;
      .trangle {
        width: 34px;
        height: 34px;
        z-index: 1111;
        position: absolute;
        &.trangle1 {
          left: 0px;
          top: 0px;
        }
        &.trangle2 {
          right: -4px;
          bottom: -4px;
          transform: rotate(180deg);
        }
        &.trangle3 {
          left: 0px;
          bottom: -4px;
          transform: rotate(-90deg);
        }
      }
      .trangleRight {
        width: 217px;
        height: 96px;
        position: absolute;
        right: -4px;
        top: 0px;
        z-index: 12;
      }
      .serveMap {
        border: 2px solid #2785dc;
        width: 100%;
        height: 100%;
      }
    }
  }
  .homeCenter {
    width: 27%;
    margin-left: 12px;
    .socialCenterTop {
      width: 100%;
      position: relative;
      height: 44vh;
      .serveObjTop {
        padding-top: 18%;
        height: 30vh;
        position: relative;
        z-index: 99;
        .sertitle {
          color: #fff;
          font-size: 18px;
          margin-left: 20px;
        }
        .today {
          margin-top: 3%;
          margin-bottom: 3%;
        }
        .serveBox {
          padding: 20px 15px;
          display: flex;
          justify-content: space-between;
          height: 67px;
          .serveOther {
            flex: 1;
            text-align: center;
            cursor: pointer;
            img {
              width: 34px;
              height: 32px;
              margin-left: -12%;
              margin-right: 20px;
            }
            p {
              display: inline-block;
              .name {
                color: #fff;
                font-size: 12px;
                text-align: center;
                display: inline-block;
                margin-bottom: 5px;
              }
              .nums {
                font-size: 20px;
                color: #fa7093;
                font-weight: bold;
                display: inline-block;
                margin-top: 8px;
              }
            }
          }
          .serveItem {
            position: relative;
            width: 34px;
            height: 32px;
            .name {
              width: 80px;
              line-height: 24px;
              color: #fff;
              font-size: 12px;
              text-align: center;
              padding-left: 60px;
            }
            .nums {
              font-size: 20px;
              font-weight: bold;
              width: 80px;
              text-align: center;
              line-height: 38px;
              padding-left: 60px;
              color: #fff;
              padding-top: 4px;
            }
            // background: #01b1ff;
            &.serveItem1 {
              margin: 0px 15px;
            }
          }
        }
      }
    }
    .socialCenterBottom {
      width: 100%;
      position: relative;
      height: 45vh;
      margin-top: 12px;
      .serveTitle {
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        padding-left: 22px;
        padding-top: 20px;
      }
      .inspectionTop {
        display: flex;
        align-items: center;
        padding: 12px;
        text-align: center;
        .itemSite {
          width: 122px;
          .siteTitle {
            color: #e4e4e4;
            font-size: 15px;
          }
          .siteShaw {
            width: 88px;
            height: 40px;
            line-height: 40px;
            margin: 12px auto 0;
            color: #01b1ff;
            background: #041235;
            box-shadow: 0px 0px 6px #02629a;
          }
        }
      }
      #socialOld {
        width: 100%;
        margin-top: 10px;
        height: 26vh;
      }
    }
  }
  .homeRight {
    width: 27.5%;
    margin-left: 12px;
    .socialRightTop {
      width: 100%;
      position: relative;
      height: 44vh;
      .inspectionTop {
        display: flex;
        align-items: center;
        padding: 12px;
        text-align: center;
        .itemSite {
          width: 122px;
          .siteTitle {
            color: #e4e4e4;
            font-size: 15px;
          }
          .siteShaw {
            width: 88px;
            height: 40px;
            line-height: 40px;
            margin: 12px auto 0;
            color: #01b1ff;
            background: #041235;
            box-shadow: 0px 0px 6px #02629a;
          }
        }
      }
      #safe {
        width: 100%;
        margin-top: 10px;
        height: 22vh;
      }
    }
    .socialRightBottom {
      width: 100%;
      position: relative;
      height: 45vh;
      margin-top: 12px;
      .videoBox {
        position: relative;
        z-index: 10;
        padding: 12px;
        height: 38vh;
        display: flex;
        .videoflex::-webkit-scrollbar {
          display: none;
        }
        .videoflex {
          flex: 1;
          position: relative;
        }
        .videoSmall {
          width: 127px;
          height: 38vh;
          overflow: scroll;
          margin-left: 12px;
          -ms-overflow-style: none;
          overflow: -moz-scrollbars-none;
          li {
            width: 127px;
            height: 112px;
            margin-bottom: 12px;
            img {
              width: 127px;
              height: 112px;
            }
            &:last-child {
              margin-bottom: 0px;
            }
          }
        }
        .videoSmall::-webkit-scrollbar {
          display: none;
        }
      }
    }
  }
}
/deep/.amap-info-contentContainer {
  .bottom-right {
    width: 420px;
  }
}
/deep/.amap-info-content {
  // width: 200px;
  // height: 250px;
  padding: 0;
  background: rgba(0, 30, 65, 0.8);
  z-index: 2000;
  .mapTitle {
    height: 40px;
    color: #fff;
    background: rgba(0, 60, 125, 1);
    padding: 0 15px;
    line-height: 40px;
    font-size: 16px;
    display: flex;
    span {
      flex: 1;
    }
    .icon {
      font-size: 16px;
      line-height: 40px;
      cursor: pointer;
    }
  }
  .mapUl {
    padding: 15px;
    .mapLi {
      display: flex;
      line-height: 30px;
      line-height: 30px;
      font-size: 30px;
      font-size: 14px;
      color: #fff;
      .name {
        width: 110px;
        text-align: right;
      }
      .content {
        flex: 1;
        margin-right: 10px;
      }
      .imgs {
        width: 100px;
        height: 100px;
      }
    }
  }
  .baseinfo {
    margin: 40px 0 20px 18px;
    img {
      width: 14px;
      height: 14px;
      margin-right: 4px;
    }
    span {
      color: #01b1ff;
      font-size: 20px;
    }
  }
  .serverUrl {
    margin-left: 20px;
    overflow: hidden;
    .width {
      float: left;
      img {
        width: 96px;
        height: 96px;
        margin-right: 14px;
      }
      p {
        color: #ffffff;
        font-size: 14px;
        margin-bottom: 5px;
      }
    }
    li.oth {
      color: #fff;
      font-size: 14px;
      margin-top: 20px;
      margin-bottom: 3px;
    }
  }
  .orderinfo {
    overflow: hidden;
    margin-left: 20px;
    margin-right: 20px;
    li {
      float: left;
      width: 50%;
      color: #fff;
      font-size: 14px;
    }
  }
}
.maskModel {
  width: 650px;
  height: 630x;
  background: rgba(2, 29, 54, 1);
  border: 1px solid rgba(110, 188, 255, 1);
  position: absolute; /*参照物是父容器*/
  left: 50%;
  top: 5%;
  transform: translateX(-50%); /*百分比的参照物是自身*/
  z-index: 2000;
  .yearMoney {
    display: flex;
    justify-content: center;
    height: 40px;
    line-height: 40px;
    color: #fff;
    padding: 0px 12px;
    background: rgba(0, 60, 125, 1);
    .name {
      color: #fff;
      font-size: 16px;
      flex: 1;
    }

    .maskClose {
      width: 19px;
      height: 19px;
      position: relative;
      top: 10px;
      right: 5px;
      cursor: pointer;
    }
  }
  .noflex {
    display: block;
  }
  .ruyuanInfo {
    margin: 20px 18px;
    li {
      width: 100%;
      color: #fff;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
    }
  }
}
.personFlex {
  display: flex;
  align-items: center;
  padding: 30px 15px;
  .img {
    width: 150px;
    height: 150px;
    margin-right: 15px;
    margin-top: 5px;
  }
  .personConent {
    flex: 1;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    line-height: 30px;
  }
}
.maskTab {
  background: linear-gradient(to right, #01b1ff, #2e9eff);
  margin: 12px 12px 0px;
  display: flex;
  line-height: 40px;
  color: #fff;
  font-size: 15px;
  height: 40px;
  text-align: center;
  .item {
    flex: 1;
  }
  .item2 {
    flex: 2;
  }
}
</style>
